import qs from 'qs'

export const queryProgramsPageThumbnail = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `programs-page?${query}`
}
